import Jsona from 'jsona'

export const deserialize = function (data) {
    const dataFormatter = new Jsona()

    return dataFormatter.deserialize(data)
}
